const basePath = 'https://assets.cdn.feather-insurance.com/assets/images';
const basePathIllustrations = `${basePath}/illustrations`;

const images = {
  aid: `${basePath}/aid.svg`,
  bed: `${basePath}/bed.svg`,
  bigDog: `${basePath}/bigDog.svg`,
  verticalIcons: {
    dogLiability: `${basePath}/dogLiabilityIcon.png`,
    dogLiability2x: `${basePath}/dogLiabilityIcon2x.png`,
    dogLiability3x: `${basePath}/dogLiabilityIcon3x.png`,
    lifeIcon: `${basePath}/lifeIcon.png`,
    lifeIcon2x: `${basePath}/lifeIcon2x.png`,
    lifeIcon3x: `${basePath}/lifeIcon3x.png`,
  },
  brokenAquarium: `${basePath}/brokenAquarium.svg`,
  brokenGlass: `${basePath}/brokenGlass.svg`,
  damagedLaptop: `${basePath}/damagedLaptop.svg`,
  moneyIncome: `${basePath}/moneyIncome.svg`,
  washingMachine: `${basePath}/washingMachine.svg`,
  bill: `${basePath}/bill.svg`,
  books: `${basePath}/books.svg`,
  finalExpenses: `${basePath}/finalExpenses.svg`,
  mortgage: `${basePath}/mortgage.svg`,
};

const illustrations = {
  aids: `${basePathIllustrations}/aids.svg`,
  allInOneAccount: `${basePathIllustrations}/all-in-one-account.svg`,
  ambulance: `${basePathIllustrations}/ambulance.svg`,
  bank: `${basePathIllustrations}/bank.svg`,
  battery: `${basePathIllustrations}/battery.svg`,
  bed: `${basePathIllustrations}/bed.svg`,
  bigDog: `${basePathIllustrations}/big-dog.svg`,
  bikeDamage: `${basePathIllustrations}/bike-damage.svg`,
  bikeDestroyedDamaged: `${basePathIllustrations}/bike-destroyed-damaged.svg`,
  bikeDetails: `${basePathIllustrations}/bike-details.svg`,
  bikeFrameNumber: `${basePathIllustrations}/bike-frame-number.svg`,
  bikeLock: `${basePathIllustrations}/bike-lock.svg`,
  bikeParts: `${basePathIllustrations}/bike-parts.svg`,
  bikeRiding: `${basePathIllustrations}/bike-riding.svg`,
  bikeStolenBroken: `${basePathIllustrations}/bike-stolen-broken.svg`,
  bikeStolen: `${basePathIllustrations}/bike-stolen.svg`,
  bikeTrailer: `${basePathIllustrations}/bike-trailer.svg`,
  bikeWear: `${basePathIllustrations}/bike-wear.svg`,
  bike: `${basePathIllustrations}/bike.svg`,
  bill: `${basePathIllustrations}/bill.svg`,
  bookOpen: `${basePathIllustrations}/book-open.svg`,
  briefcase: `${basePathIllustrations}/briefcase.svg`,
  brokenAquarium: `${basePathIllustrations}/broken-aquarium.svg`,
  brokenGlass: `${basePathIllustrations}/broken-glass.svg`,
  calculating1: `${basePathIllustrations}/calculating-1.svg`,
  calculatingDone: `${basePathIllustrations}/calculating-done.svg`,
  calculating: `${basePathIllustrations}/calculating.svg`,
  calendar: `${basePathIllustrations}/calendar.svg`,
  car: `${basePathIllustrations}/car.svg`,
  checkDoc: `${basePathIllustrations}/check-doc.svg`,
  check: `${basePathIllustrations}/check.svg`,
  concierge: `${basePathIllustrations}/concierge.svg`,
  contract: `${basePathIllustrations}/contract.svg`,
  crash: `${basePathIllustrations}/crash.svg`,
  creditCard: `${basePathIllustrations}/credit-card.svg`,
  damagedLaptop: `${basePathIllustrations}/damaged-laptop.svg`,
  dentalCleaning: `${basePathIllustrations}/dental-cleaning.svg`,
  dentalTreatment: `${basePathIllustrations}/dental-treatment.svg`,
  dental: `${basePathIllustrations}/dental.svg`,
  dependents: `${basePathIllustrations}/dependents.svg`,
  document1: `${basePathIllustrations}/document-1.svg`,
  documentCheck: `${basePathIllustrations}/document-check.svg`,
  documentCross: `${basePathIllustrations}/document-cross.svg`,
  document: `${basePathIllustrations}/document.svg`,
  door: `${basePathIllustrations}/door.svg`,
  education: `${basePathIllustrations}/education.svg`,
  electricCar: `${basePathIllustrations}/electric-car.svg`,
  email: `${basePathIllustrations}/email.svg`,
  euroMoney: `${basePathIllustrations}/euro-money.svg`,
  fastEasy: `${basePathIllustrations}/fast-easy.svg`,
  fire: `${basePathIllustrations}/fire.svg`,
  freelancerExpat: `${basePathIllustrations}/freelancer-expat.svg`,
  funeralBurial: `${basePathIllustrations}/funeral-burial.svg`,
  fuse: `${basePathIllustrations}/fuse.svg`,
  giftPolicyOptionsQuote: `${basePathIllustrations}/gift-policy-options-quote.svg`,
  grandmother: `${basePathIllustrations}/grandmother.svg`,
  healthCard: `${basePathIllustrations}/health-card.svg`,
  heart: `${basePathIllustrations}/heart.svg`,
  helmet: `${basePathIllustrations}/helmet.svg`,
  householdHome: `${basePathIllustrations}/household-home.svg`,
  keys: `${basePathIllustrations}/keys.svg`,
  legalLawyer: `${basePathIllustrations}/legal-lawyer.svg`,
  location: `${basePathIllustrations}/location.svg`,
  lock: `${basePathIllustrations}/lock.svg`,
  mail: `${basePathIllustrations}/mail.svg`,
  medicine: `${basePathIllustrations}/medicine.svg`,
  mentalHealth: `${basePathIllustrations}/mental-health.svg`,
  mentalIllness: `${basePathIllustrations}/mental-llness.svg`,
  miniJobExpat: `${basePathIllustrations}/minijob-expat.svg`,
  moneyIncome: `${basePathIllustrations}/money-income.svg`,
  movingTruck: `${basePathIllustrations}/moving-truck.svg`,
  naturalRemedies: `${basePathIllustrations}/natural-remedies.svg`,
  newArrival: `${basePathIllustrations}/new-arrival.svg`,
  noPolicies: `${basePathIllustrations}/no-policies.svg`,
  passport: `${basePathIllustrations}/passport.svg`,
  pawPet: `${basePathIllustrations}/paw-pet.svg`,
  pen: `${basePathIllustrations}/pen.svg`,
  personB: `${basePathIllustrations}/person-b.svg`,
  person: `${basePathIllustrations}/person.svg`,
  petsBunny: `${basePathIllustrations}/pets-bunny.svg`,
  petsCat: `${basePathIllustrations}/pets-cat.svg`,
  phone1: `${basePathIllustrations}/phone-1.svg`,
  phone2Fa: `${basePathIllustrations}/phone-2-fa.svg`,
  phonePerson: `${basePathIllustrations}/phone-person.svg`,
  phonePhoto: `${basePathIllustrations}/phone-photo.svg`,
  phone: `${basePathIllustrations}/phone.svg`,
  photoPerson: `${basePathIllustrations}/photo-person.svg`,
  pipes: `${basePathIllustrations}/pipes.svg`,
  planeRepatriationFlight: `${basePathIllustrations}/plane-repatriation-flight.svg`,
  pregnancy: `${basePathIllustrations}/pregnancy.svg`,
  productionDown: `${basePathIllustrations}/production-down.svg`,
  pushNotifications: `${basePathIllustrations}/push-notifications.svg`,
  radioactive: `${basePathIllustrations}/radioactive.svg`,
  referral: `${basePathIllustrations}/referral.svg`,
  researcherExpat: `${basePathIllustrations}/researcher-expat.svg`,
  restrictions: `${basePathIllustrations}/restrictions.svg`,
  ring: `${basePathIllustrations}/ring.svg`,
  screen: `${basePathIllustrations}/screen.svg`,
  screenings: `${basePathIllustrations}/screenings.svg`,
  shield1: `${basePathIllustrations}/shield-1.svg`,
  shield2: `${basePathIllustrations}/shield-2.svg`,
  shield3: `${basePathIllustrations}/shield-3.svg`,
  shieldCross: `${basePathIllustrations}/shield-cross.svg`,
  shieldQuestionMark: `${basePathIllustrations}/shield-questionmark.svg`,
  shieldWarning: `${basePathIllustrations}/shield-warning.svg`,
  shield: `${basePathIllustrations}/shield.svg`,
  sign: `${basePathIllustrations}/sign.svg`,
  spinner: `${basePathIllustrations}/spinner.svg`,
  sportLifestyleBasketball: `${basePathIllustrations}/sport-lifestyle-basketball.svg`,
  storm: `${basePathIllustrations}/storm.svg`,
  studentExpat: `${basePathIllustrations}/student-expat.svg`,
  submit: `${basePathIllustrations}/submit.svg`,
  supportAgent: `${basePathIllustrations}/support-agent.svg`,
  supportSpeakingMessageChatTalk: `${basePathIllustrations}/support-speaking-message-chat-talk.svg`,
  theft: `${basePathIllustrations}/theft.svg`,
  time: `${basePathIllustrations}/time.svg`,
  traffic: `${basePathIllustrations}/traffic.svg`,
  tree: `${basePathIllustrations}/tree.svg`,
  user: `${basePathIllustrations}/user.svg`,
  vaccination: `${basePathIllustrations}/vaccination.svg`,
  vandalism: `${basePathIllustrations}/vandalism.svg`,
  videoCall: `${basePathIllustrations}/video-call.svg`,
  visaSeekerExpat: `${basePathIllustrations}/visa-seeker-expat.svg`,
  visa: `${basePathIllustrations}/visa.svg`,
  visualAid: `${basePathIllustrations}/visual-aid.svg`,
  visual: `${basePathIllustrations}/visual.svg`,
  washingMachine: `${basePathIllustrations}/washing-machine.svg`,
  water: `${basePathIllustrations}/water.svg`,
  wavingHand: `${basePathIllustrations}/waving-hand.svg`,
  worldwide: `${basePathIllustrations}/worldwide.svg`,
};

type IllustrationKeys = keyof typeof illustrations;

export type { IllustrationKeys }
export { illustrations, images };
